"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadFontsForStorybook = void 0;
/* eslint-env browser */
var global_1 = require("./global");
// Load the font and avoid re-loading it when components change
var fontLinkId = 'storybook-font-link-tag';
exports.loadFontsForStorybook = function () {
    if (!document.getElementById(fontLinkId)) {
        var fontLink = document.createElement('link');
        fontLink.id = fontLinkId;
        fontLink.href = global_1.fontUrl;
        fontLink.rel = 'stylesheet';
        document.head.appendChild(fontLink);
    }
};
//# sourceMappingURL=loadFonts.js.map